"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Draggable = Draggable;
exports.useDraggable = useDraggable;

var _react = require("react");

var _propTypes = require("prop-types");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Draggable(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return children(useDraggable(rest));
}

Draggable.propTypes = {
  children: _propTypes.func.isRequired,
  controlStyle: _propTypes.bool,
  rectLimits: (0, _propTypes.shape)({
    left: _propTypes.number,
    right: _propTypes.number,
    top: _propTypes.number,
    bottom: _propTypes.number
  }),
  viewport: _propTypes.bool
};

function useDraggable() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      controlStyle = _ref2.controlStyle,
      _ref2$viewport = _ref2.viewport,
      viewport = _ref2$viewport === void 0 ? false : _ref2$viewport,
      rectLimits = _ref2.rectLimits;

  var targetRef = (0, _react.useRef)(null);
  var handleRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      dragging = _useState2[0],
      setDragging = _useState2[1];

  var _useState3 = (0, _react.useState)({
    x: 0,
    y: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      prev = _useState4[0],
      setPrev = _useState4[1];

  var _useState5 = (0, _react.useState)({
    x: 0,
    y: 0
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      delta = _useState6[0],
      setDelta = _useState6[1];

  var initial = (0, _react.useRef)({
    x: 0,
    y: 0
  });
  var limits = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var handle = handleRef.current || targetRef.current;
    handle.addEventListener('mousedown', startDragging);
    handle.addEventListener('touchstart', startDragging);
    return function () {
      handle.removeEventListener('mousedown', startDragging);
      handle.removeEventListener('touchstart', startDragging);
    };

    function startDragging(event) {
      event.preventDefault();
      setDragging(true);
      var source = event.touches && event.touches[0] || event;
      var clientX = source.clientX,
          clientY = source.clientY;
      initial.current = {
        x: clientX,
        y: clientY
      };

      if (controlStyle) {
        targetRef.current.style.willChange = 'transform';
      }

      if (viewport || rectLimits) {
        var _targetRef$current$ge = targetRef.current.getBoundingClientRect(),
            left = _targetRef$current$ge.left,
            top = _targetRef$current$ge.top,
            width = _targetRef$current$ge.width,
            height = _targetRef$current$ge.height;

        if (viewport) {
          limits.current = {
            minX: -left + delta.x,
            maxX: window.innerWidth - width - left + delta.x,
            minY: -top + delta.y,
            maxY: window.innerHeight - height - top + delta.y
          };
        } else {
          limits.current = {
            minX: rectLimits.left - left + delta.x,
            maxX: rectLimits.right - width - left + delta.x,
            minY: rectLimits.top - top + delta.y,
            maxY: rectLimits.bottom - height - top + delta.y
          };
        }
      }
    }
  }, [controlStyle, viewport, delta, rectLimits]);
  (0, _react.useEffect)(function () {
    var handle = handleRef.current || targetRef.current;

    if (dragging) {
      document.addEventListener('mousemove', reposition, {
        passive: true
      });
      document.addEventListener('touchmove', reposition, {
        passive: true
      });
      document.addEventListener('mouseup', stopDragging);
      document.addEventListener('touchend', stopDragging);
    } else {
      document.removeEventListener('mousemove', reposition, {
        passive: true
      });
      document.removeEventListener('mouseup', stopDragging);
      document.removeEventListener('touchmove', reposition, {
        passive: true
      });
      document.removeEventListener('touchend', stopDragging);
    }

    if (controlStyle) {
      handle.style.cursor = dragging ? 'grabbing' : 'grab';
    }

    return function () {
      if (controlStyle) {
        handle.style.cursor = '';
      }

      document.removeEventListener('mousemove', reposition, {
        passive: true
      });
      document.removeEventListener('mouseup', stopDragging);
      document.removeEventListener('touchmove', reposition, {
        passive: true
      });
      document.removeEventListener('touchend', stopDragging);
    };

    function stopDragging(event) {
      event.preventDefault();
      setDragging(false);
      var newDelta = reposition(event);
      setPrev(newDelta);

      if (controlStyle) {
        targetRef.current.style.willChange = '';
      }
    }

    function reposition(event) {
      var source = event.changedTouches && event.changedTouches[0] || event.touches && event.touches[0] || event;
      var clientX = source.clientX,
          clientY = source.clientY;
      var x = clientX - initial.current.x + prev.x;
      var y = clientY - initial.current.y + prev.y;
      var newDelta = calcDelta({
        x: x,
        y: y,
        limits: limits.current
      });
      setDelta(newDelta);
      return newDelta;
    }
  }, [dragging, prev, controlStyle, viewport, rectLimits]);
  (0, _react.useEffect)(function () {
    if (controlStyle) {
      targetRef.current.style.transform = "translate(".concat(delta.x, "px, ").concat(delta.y, "px)");
    }
  }, [delta, controlStyle]);
  var getTargetProps = (0, _react.useCallback)(function () {
    return {
      'aria-grabbed': dragging || null
    };
  }, [dragging]);
  var resetState = (0, _react.useCallback)(function () {
    setDelta({
      x: 0,
      y: 0
    });
    setPrev({
      x: 0,
      y: 0
    });
  }, [setDelta, setPrev]);
  return {
    targetRef: targetRef,
    handleRef: handleRef,
    getTargetProps: getTargetProps,
    dragging: dragging,
    delta: delta,
    resetState: resetState
  };
}

function calcDelta(_ref3) {
  var x = _ref3.x,
      y = _ref3.y,
      limits = _ref3.limits;

  if (!limits) {
    return {
      x: x,
      y: y
    };
  }

  var minX = limits.minX,
      maxX = limits.maxX,
      minY = limits.minY,
      maxY = limits.maxY;
  return {
    x: Math.min(Math.max(x, minX), maxX),
    y: Math.min(Math.max(y, minY), maxY)
  };
}